const routes = {
    home: '/',
    about: '/aboutus',
    news: '/news',
    blogs: '/news/post/:id',
    viewSingleBlog: '/news/:slug',
    share: '/shareyourstory',
    feedback: '/feedback',
    resources: '/resources',
    infographics: '/resources/infographics',
    countries: '/countries',
    story: '/resources/story',
    event: '/resources/events',
    admin: '/administration',
    adminLogin: '/login',
    adminOverview: '/administration/',
    adminResource: '/administration/resources',
    adminCountry: '/administration/country',
    adminBlog: '/administration/blog',
    adminCreateBlog: '/administration/blog/createblog',
    adminBlogPreview: '/administration/blog/preview',


};

export default routes;
